import { accountBadgeEntityName } from '../../../../../backend/features/badges/shared';
import { AccountOrganizationSelect } from '../../../../../ui/features/badge-management/components/BadgeAccountsSelectionPanel/AccountOrganizationSelect';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
export const AccountBadgeSettingsDialog = ({ titleText, subTitleText, cancelText, submitText, accountBadge, onClose, onSubmit, extendAccountBadgeOptionComponents, }) => {
    var _a;
    const now = new Date().getTime();
    const [options, setOptions] = useState(undefined);
    const { data: accountBadgeFresh, isLoading: isAccountBadgeLoading } = useStorageGet(accountBadgeEntityName, accountBadge.id);
    const { data: account, isLoading: isAccountLoading } = useStorageGet(accountEntityName, accountBadge.columns.accountId);
    if (isAccountBadgeLoading || isAccountLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (!accountBadgeFresh || !account) {
        return null;
    }
    const optionsComputed = Object.assign(Object.assign({}, accountBadgeFresh.data.options), options);
    const accountSelection = {
        id: account.id,
        account: account.columns,
        options: optionsComputed,
    };
    const optionComponentsDefault = [AccountOrganizationSelect];
    const optionComponents = (_a = extendAccountBadgeOptionComponents === null || extendAccountBadgeOptionComponents === void 0 ? void 0 : extendAccountBadgeOptionComponents(optionComponentsDefault)) !== null && _a !== void 0 ? _a : optionComponentsDefault;
    const handleOptionsPartialChange = (optionsChange) => {
        setOptions(Object.assign(Object.assign({}, options), optionsChange));
    };
    const handleSubmitClick = () => {
        onSubmit(optionsComputed);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, titleText),
        React.createElement(DialogContent, null,
            React.createElement(Typography, { sx: { mb: 2 } }, subTitleText),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                } }, optionComponents.map((OptionComp, i) => {
                return (React.createElement(OptionComp, { key: `${now}-${i}`, sx: { width: '100%', height: 45 }, accountSelection: accountSelection, onOptionsPartialChange: handleOptionsPartialChange }));
            }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', "data-test": 'form-dialog-submit-button', onClick: onClose }, cancelText),
            React.createElement(Button, { color: 'primary', "data-test": 'form-dialog-submit-button', onClick: handleSubmitClick }, submitText))));
};
